import Box from '@zenbusiness/zui/Box';
import SharedAsset from '@zenbusiness/zui/SharedAsset';
import { styled } from '@zenbusiness/zui/styles';

const ImageStyle = () => ({
  width: '100%'
});

const ImageWrapperStyle = ({ theme }) => ({
  gridColumn: '2 / 4',
  width: '100%',
  textAlign: 'end',
  [theme.breakpoints.up('sm')]: {
    gridColumn: '3 / 5',
    textAlign: 'end'
  },
  [theme.breakpoints.up('md')]: {
    gridColumn: '1 / 7',
    textAlign: 'end'
  }
});

const ContentWrapperStyle = ({ theme }) => ({
  gridColumn: '1 / 5',
  [theme.breakpoints.up('sm')]: {
    gridColumn: '1 / 7'
  },
  [theme.breakpoints.up('md')]: {
    gridColumn: '7 / 13'
  }
});

export const ImageStyled = styled(SharedAsset)(ImageStyle);
export const ImageWrapper = styled(Box)(ImageWrapperStyle);
export const ContentWrapper = styled(Box)(ContentWrapperStyle);
